const safariRegEx = /^((?!chrome|android).)*safari/i;

/**
 * @returns bool of whether the user agent is from safari or not
 */
function isSafari( userAgentString: string ): boolean {
    return safariRegEx.test( userAgentString );
}

export {
    isSafari,
};
